import { createContext, useState, useEffect, useContext } from "react";
import { isLogin, connectWallet } from "../Helper/Functions";
import AxiosInstance from './AxiosInstance'
const AppContext = createContext({});

export const ContextProvider = ({ children }) => {
    const [profile, setProfile] = useState({ userId: null, verifed: false, walletAddress: null });
    const [Bep20Provider, setBep20Provider] = useState(null);
    const fetchProfile = async () => {
        try {
            if (!profile?.userId) return
            const response = await AxiosInstance.get('/users/get-Profile')
            if (response.success) { setProfile((prev) => ({ ...prev, ...response.user })) }
        } catch (err) { }
    }
    const verifyAuth = () => {
        try {
            setProfile((prev) => ({ ...prev, verifed: false }))
            const { id = null } = isLogin()
            setProfile(prev => ({ ...prev, userId: id, verifed: true }))
            if (id && !profile?.userId) { fetchProfile() }
        } catch (err) { } finally {
            setProfile((prev) => ({ ...prev, verifed: true }))
        }
    };
    const logOut = () => {
        localStorage.removeItem("token");
        setProfile(prev => ({ ...prev, userId: null, verifed: true }))
    };
    const ConnectWallet = async () => {
         setProfile(prev=>({ ...prev, walletAddress: null }))
         const { provider, signer } = await connectWallet()
         if(!signer?.address) return 
         setProfile(prev=>({ ...prev, walletAddress: signer?.address }))
         setBep20Provider(provider)
    };

    useEffect(() => { verifyAuth() }, []);
    useEffect(() => { fetchProfile() }, [profile?.userId]);

    return (
        <AppContext.Provider value={{ verifyAuth, Bep20Provider, ConnectWallet, profile, setProfile, isLogin, logOut, fetchProfile }}>
            {children}
        </AppContext.Provider>
    );
};

export const Context = () => {
    return useContext(AppContext);
};
